<template>
  <div id="app">
    <div
      v-if="$root.ready && overflow"
      class="ready-overflow"
      @click="openWebsite()"
    >
      <button
        class="btn btn-outline-primary text-uppercase"
        @click="openWebsite()"
      >
        Buka Undangan
      </button>
    </div>

    <AGWAudio ref="audio" :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan"/>
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes"/>
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="pad-y-60"/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.5036496034722!2d115.12426831478524!3d-8.832610993657243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0!2zOMKwNDknNTcuNCJTIDExNcKwMDcnMzUuMyJF!5e0!3m2!1sen!2sid!4v1610377453700!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.832611,115.126457/@-8.832611,115.1242683,17z/data=!4m2!4m1!3e0"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <Himbauan />
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/suadnyana-mita/OKA00576-Edit_Pw85ElHdznq.jpg?tr=w-1024'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/suadnyana-mita/OKA00688-Edit_GYQIkFmv1.jpg?tr=w-1024'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/ceremonyku/suadnyana-mita/OKA00418-Edit_tRVxYSzXB.jpg?tr=w-1024'

import Audio from "@/assets/audio/backsound.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Himbauan from '@/components/Himbauan.vue';
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
  },
  data() {
    return {
      title: 'Pawiwahan',
      backgrounds: [ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      wedding: {
        man: {
          name: 'I Wayan Suadnyana., A.Md',
          surname: 'Suadnyana',
          parents: 'I Ketut Kartika & Ni Made Karmiani',
          description: 'Putra pertama',
          address: 'Br. Dinas Tambyak, Pecatu, Badung - Bali',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/suadnyana-mita/edit__2__TjtTdboHr.jpg?tr=w-400',
        },
        woman: {
          name: 'Ni Luh Putu Mita Pramestya Utami., SE',
          surname: 'Mita',
          parents: 'I Made Terima Jaya & Ni Nyoman Ariani',
          address: 'Br. Dinas Kelod, Ungasan, Badung - Bali',
          description: 'Putri pertama',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/suadnyana-mita/edit__1__ALQAuMbrQcF.jpg?tr=w-400',
        },
      },
      location: "Jl. Raya Uluwatu, Pecatu Rumah Keluarga Besar Tambyak Pecatu, Badung - Bali",
      time: {
        start: this.$moment("2021-01-20 12:00"),
        end: "Selesai"
      },
      mepandes: [
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
      this.sw.refreshing = true;
      window.location.reload();
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  }
};
</script>
